import React from "react";
import { IconButton } from "@mui/material";

const SocialIcon = ({
  icon,
  link,
}) => {
  return (
    <IconButton
      component="a"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        borderRadius: '50%',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        width: '40px',
        height: '40px',
        padding: '8px',
        color: 'rgba(255, 255, 255, 0.6)',
        background: 'transparent',
        '&:hover': {
          background: 'rgba(255, 255, 255, 0.1)',
          color: '#FFFFFF'
        }
      }}
    >
      {icon}
    </IconButton>
  );
};

export default SocialIcon; 